<template>
  <div class="Finish"> 
    <div ref="txt" class="Finish__txt"><div v-html="trans('GLOBAL.finish')"/></div>
    <Description ref="description" indice="conclusion"/>
    <div class="Bottom">
      <div ref="button" class="Button" @click="onClick()">{{ trans('GLOBAL.finish_button') }}</div>
    </div> 
  </div> 
</template>

<script>

import gsap from "gsap"
import Description from "./assets/Description.vue"

export default {

  name: 'Finish',
  components: { Description },
  mounted() {
    this.$nextTick(()=>{
      gsap.from(this.$refs.txt, { duration: .5, opacity: 0, ease: 'none', delay: .25 })
      gsap.from([  this.$refs.description.$el, this.$refs.button ], {
        duration: .5, 
          y: '+=400%', 
          ease: 'cubic.out', 
          stagger: .2,
          delay: .5, 
      })
    })
  },
  methods:{  
    onClick() {
      this.$store.commit('app/UPDATE_STATUS', 'logo')
      gsap.delayedCall(.25, ()=>{ 
        this.$router.push({ params: { section: undefined, step: undefined } })
      })
    },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Finish
  position absolute
  top 0
  left 0
  color white
  width 100%
  height 100%
  display flex 
  flex-direction column
  justify-content flex-end
  align-items center

  &__txt 
    text-align center
    height 66%
    display flex
    align-items center
    font-size 2.13em
    line-height 1.15em
    font-family SpaceGrotesk

</style>


